module.exports = __webpack_public_path__ + "static/media/3_2_CAM.019e9846.png";